"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var initialContext = {
    query: function () {
        console.warn('Add ClientProvider to use client context');
        return Promise.resolve({ error: true, status: 0 });
    },
};
exports.ClientContext = react_1.createContext(initialContext);
